<template>
  <div class="flex justify-center col-span-2 gap-1">
    <button
      class="btn btn-xs text-my-gray px-3"
      @click="store.addDialog(3, '', i)"
    >
      +{{ t(`game.role.3`) }}
    </button>
    <button
      class="btn btn-xs text-my-gray px-3"
      @click="store.addDialog(1, '', i)"
    >
      +{{ t(`game.role.1`) }}
    </button>
    <button
      class="btn btn-xs text-my-gray px-3"
      @click="store.addDialog(2, '', i)"
    >
      +{{ t(`game.role.2`) }}
    </button>
    <button
      class="btn btn-xs text-my-gray px-3"
      @click="store.addDialog(4, '', i)"
    >
      +{{ t(`game.role.4`) }}
    </button>
    <button class="btn btn-xs text-my-gray px-3" @click="clickAiGenerate()">
      +{{ t("Buttons.ai") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ApiPostGalGameDialogGenerate } from "@/apis/gal-game";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { showLoadingToast } from "vant";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const { t } = useI18n();
const props = defineProps({
  i: {
    type: Number,
  },
});

const clickAiGenerate = async () => {
  const toast = showLoadingToast({ message: t("Message.AIGenerating") });
  try {
    const { item } = await ApiPostGalGameDialogGenerate(store.activeNode.id!);
    store.dialogMap[item.id] = item;
    const { character } = store.dialogMap[item.id];
    const { sceneMediaId, mateToneId, portraitzz } = store.getDefaultDialog(
      character.id!
    );
    if (sceneMediaId || mateToneId) {
      store.dialogMap[item.id].sceneMediaId = sceneMediaId;
      store.dialogMap[item.id].mateToneId = mateToneId;
      await store.saveDialog(store.dialogMap[item.id]);
    }
    if (portraitzz.length > 0) {
      await store.setDialogPortrait(item.id!, portraitzz);
    }

    if (props.i === undefined) store.dialogList.push(item.id!);
    else {
      store.dialogList.splice(props.i, 0, item.id!);
      await store.sortDialog();
    }
    store.nodeMap[store.activeNode.id!].dialogzzCount!++;
  } catch (e) {
    console.log(e);
  }
  toast.close();
};
</script>
